import { mapPageTags } from './pageMaps'
import { pixall_pageReady, pixall_continue } from './platforms/pixall'
import { asc_continue, asc_pageReady } from './platforms/asc'
import { mapIcoResponses } from './platforms/pixall/pageMaps'
import { gtm_pageReady } from './platforms/google'
import { sd_pageReady, sd_continue } from './platforms/shiftDigital'
import { tags3p_pageReady } from './platforms/3p'
import { if_pageReady } from './platforms/infoTrust'
import { CONDITION_TABS } from './platforms/pixall/pageId'

const fireEventReady = (page, event, dataLayer, globalState, updateGlobalState, landingContext) => {
  const linkName = dataLayer.pageInfo.linkName
  const isError = linkName?.indexOf('_error') > 0

  switch (event) {
    case 'PageReady':
      dataLayer.session.pageInstance = (Math.random() * 10000000000000000).toFixed(0)

      pixall_pageReady(dataLayer, landingContext)
      if_pageReady(dataLayer)
      gtm_pageReady(dataLayer)
      sd_pageReady(dataLayer, landingContext)
      tags3p_pageReady(dataLayer)
      asc_pageReady(dataLayer, landingContext)
      break

    case 'Continue':
      // Don't send impressions on an error link
      if (!isError && dataLayer.impressionTags) {
        dataLayer.impressions = mapPageTags(dataLayer.impressionTags, page, globalState)
        // Removed legacy ICO responses mapping since offer creation component is now always enabled
        // Clear processed tags
        dataLayer.impressionTags = []
      }

      pixall_continue(dataLayer, landingContext)

      const { pageInfo } = dataLayer
      if (linkName === 'button::nav::exterior') {
        pageInfo.conditionTab = CONDITION_TABS.exterior
      } else if (linkName?.startsWith('ico_condition')) {
        if (linkName === pageInfo.conditionTab) return

        pageInfo.conditionTab = linkName
        pixall_pageReady(dataLayer, landingContext)
      }
      sd_continue(dataLayer, globalState, updateGlobalState, landingContext)
      asc_continue(dataLayer, landingContext)

      break
    case 'SendPixallWithConsumerInfo':
      pixall_pageReady(dataLayer)
      break
    default:
      break
  }
}

export { fireEventReady }
